import { actionsFactory, props } from '@ngneat/effects';
import { AuthenticatedUser, Jwt } from '@tmx/data-access';

const appActions = actionsFactory('app');

export const handleAuthChange = appActions.create(
  'Handle Auth Change',
  props<{ user: AuthenticatedUser; jwt: Jwt; isOriginalLogin: boolean }>()
);

export const handleUserLoggedOut = appActions.create('Handle User Logged Out');

export const handleUserSwitchingAccounts = appActions.create(
  'Handle User Switching Accounts'
);

export const initBraze = appActions.create('Init Braze');

export const changeBrazeUser = appActions.create(
  'Change Braze User',
  props<{ user: AuthenticatedUser }>()
);
